

$(document).ready(function () {

    $("#compare_data_select").change(function () {
        $("#compare_data_select option:selected").each(function () {
            var selectdata = $(this).val();
            // console.log(selectdata)
            if ($(this).attr("value") == "1") {
                $(".sdata").text('"Fresh" Food');

                $(".compare_frame_left").html(' \
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-01.png?v=1667394473" alt="Icon"></div>\
                        <div class="compare_content"><p>Anti-inflammatory coconut oil</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-02.png?v=1667394487" alt="Icon"></div>\
                        <div class="compare_content"><p>No refrigeration needed</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-03.png?v=1667394577" alt="Icon"></div>\
                        <div class="compare_content"><p>Heart healthy recipe</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-04.png?v=1667394590" alt="Icon"></div>\
                        <div class="compare_content"><p>Clean nose-to-tail recipes</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-05.png?v=1667394604" alt="Icon"></div>\
                        <div class="compare_content"><p>Easy to serve</p></div>\
                    </li>\
                ');

                $(".compare_frame_right").html(' \
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Inflammatory vegetable oils</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Goodbye fridge space!</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Contains peas and legumes</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Fillers: rice, potato, peas, water</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Inconvenient</p></div>\
                    </li>\
                ');

                // console.log(selectdata)
            }
            if ($(this).attr("value") == "2") {
                $(".sdata").text("FREEZE DRIED RAW");
                $(".compare_frame_left").html(' \
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-01.png?v=1667394473" alt="Icon"></div>\
                        <div class="compare_content"><p>High antioxidants for longevity</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-02.png?v=1667394487" alt="Icon"></div>\
                        <div class="compare_content"><p>Higher protein digestibility</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-03.png?v=1667394577" alt="Icon"></div>\
                        <div class="compare_content"><p>Your hands won’t smell</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-04.png?v=1667394590" alt="Icon"></div>\
                        <div class="compare_content"><p>Meaty, yummy texture</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-05.png?v=1667394604" alt="Icon"></div>\
                        <div class="compare_content"><p>High in omega-3s</p></div>\
                    </li>\
                ');

                $(".compare_frame_right").html(' \
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Low in antioxidants</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Lower protein digestibility</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Hands smell after serving</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Lightweight and never rehydrates</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Inflammatory omega - 6s</p></div>\
                    </li>\
                ');
                // console.log(selectdata)
            }
            if ($(this).attr("value") == "3") {
                $(".sdata").text("CANNED FOOD");
                $(".compare_frame_left").html(' \
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-01.png?v=1667394473" alt="Icon"></div>\
                        <div class="compare_content"><p>High in omega-3s</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-02.png?v=1667394487" alt="Icon"></div>\
                        <div class="compare_content"><p>Heart healthy recipe</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-03.png?v=1667394577" alt="Icon"></div>\
                        <div class="compare_content"><p>Clean nose-to-tail recipes</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-04.png?v=1667394590" alt="Icon"></div>\
                        <div class="compare_content"><p>Anti-inflammatory coconut oil</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-05.png?v=1667394604" alt="Icon"></div>\
                        <div class="compare_content"><p>Easy to serve</p></div>\
                    </li>\
                ');

                $(".compare_frame_right").html(' \
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Inflammatory omega-6s</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Contains peas and legumes</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Fillers: rice, potato, peas, water</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Inflammatory vegetable oils</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Opening cans everyday</p></div>\
                    </li>\
                ');
                // console.log(selectdata)
            }
            if ($(this).attr("value") == "4") {
                $(".sdata").text("DRY KIBBLE");
                $(".compare_frame_left").html(' \
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-01.png?v=1667394473" alt="Icon"></div>\
                        <div class="compare_content"><p>Sustainable USA farm ingredients</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-02.png?v=1667394487" alt="Icon"></div>\
                        <div class="compare_content"><p>Humanely raised fresh meat</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-03.png?v=1667394577" alt="Icon"></div>\
                        <div class="compare_content"><p>Clean nose-to-tail recipes</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-04.png?v=1667394590" alt="Icon"></div>\
                        <div class="compare_content"><p>Gently baked at 170°F</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/icon-05.png?v=1667394604" alt="Icon"></div>\
                        <div class="compare_content"><p>No recalls</p></div>\
                    </li>\
                ');

                $(".compare_frame_right").html(' \
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Vitamins & minerals from China</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Inflammatory meat meals</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>High carbs up to 70%</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Hot extruded at 400°F or higher</p></div>\
                    </li>\
                    <li>\
                        <div class="compare_icon"><img src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/cross-ing.png?v=1667395064" alt="Icon"></div>\
                        <div class="compare_content"><p>Regular listeria & e-coli outbreaks</p></div>\
                    </li>\
                ');
                // console.log(selectdata)
            }
        });
    }).change();
});

// console.log("working")